var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creative-dashboard"},[(_vm.User.loaded && _vm.User.User)?_c('Dashboard'):(_vm.User.loaded && !_vm.User.User)?_c('Auth'):_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-icon"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }